// Renders admin-authored content (questions, answers, solutions) for display.
//
// Mirrors shared/richContent.js in the student app. Two cases have to be told
// apart, and getting it wrong is what made solutions unreadable there:
//
//   * Rich-editor HTML — pass through unchanged.
//   * Plain text with \n line breaks — HTML collapses newlines into spaces, so
//     a step-by-step solution renders as one run-on paragraph unless the
//     breaks are converted to <br>.
//
// Image paths are stored as /uploads/... and served from S3.

const S3_UPLOADS_BASE = "https://sv-admin-assets.s3.ap-south-1.amazonaws.com/uploads";

export const rewriteUploadsUrls = (html) =>
  (html || "").replace(
    /src="(?:https?:\/\/(?!sv-admin-assets\.s3)[^"]*)?\/uploads\//g,
    `src="${S3_UPLOADS_BASE}/`
  );

export const renderContentHtml = (value) => {
  if (!value) return "";
  const fixed = rewriteUploadsUrls(String(value));
  if (/<[a-zA-Z]/.test(fixed)) return fixed;      // already HTML
  return fixed.replace(/\n/g, "<br>");            // plain text — keep the breaks
};

export default renderContentHtml;
